module.exports = __webpack_public_path__ + "static/media/personalPage1x.2dc4e9d6.jpg";